export const DASHBOARD_VIEW = 'dashboard';

export const DASHBOARD_ROUTE_PATHS = {
  dashboard: '/dashboard',
  dashboardFullScreen: '/dashboard/fullscreen',
};
